import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import SideNav from './components/SideNav';
import RequireAccess from './components/RequireAccess';
import { UnreadLeadsProvider } from './lib/unreadLeads';
import { CurrentUserProvider } from './lib/currentUser';
import Dashboard from './pages/Dashboard';
import MyDay from './pages/MyDay';
import LeadsPage from './pages/Leads';
import LeadDetail from './pages/LeadDetail';
import DeadLeads from './pages/DeadLeads';
import ServiceAdvisor from './pages/ServiceAdvisor';
import TriagePage from './pages/Triage';
import Customers from './pages/Customers';
import CustomerDetail from './pages/CustomerDetail';
import Inventory from './pages/Inventory';
import CompliancePage from './pages/Compliance';
import PilotKpiScorecard from './pages/PilotKpiScorecard';
import SettingsPage from './pages/Settings';
import Team from './pages/Team';
import DealsPage from './pages/Deals';
import DealDetail from './pages/DealDetail';
import QuotesPage from './pages/Quotes';
import QuoteBuilder from './pages/QuoteBuilder';
import HelpPage from './pages/Help';
import ChannelMonitor from './pages/ChannelMonitor';
import Appointments from './pages/Appointments';
import DiarySettings from './pages/DiarySettings';
import Tasks from './pages/Tasks';
import PipelineSettings from './pages/PipelineSettings';
import TestDrives from './pages/TestDrives';
import LoanCars from './pages/LoanCars';
import Appraisals from './pages/Appraisals';
import Campaigns from './pages/Campaigns';
import Surveys from './pages/Surveys';
import Analytics from './pages/Analytics';
import Onboarding from './pages/Onboarding';
import PlanBilling from './pages/PlanBilling';
import DealerHealth from './pages/DealerHealth';
import { TourProvider } from './lib/tour';

export default function App() {
  return (
    <BrowserRouter>
      {/* CurrentUserProvider is outermost inside the router: the role-specific
          dashboards, My Day and the nav all need to know who is signed in, and
          it also hydrates the organization timezone before the diary renders. */}
      <CurrentUserProvider>
      {/* TourProvider sits inside the router — the tour navigates between pages,
          so it needs useNavigate. */}
      <TourProvider>
      <UnreadLeadsProvider>
      <div className="app-layout">
        <SideNav />
        <main className="app-main">
          {/* One guard for every route — the rule comes from the nav table in
              lib/apps.js, so nav visibility and reachability cannot drift. */}
          <RequireAccess>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            {/* The consultant's landing view. Dashboard also renders it inline
                for SALES_CONSULTANT, but it keeps its own route so the nav,
                notifications and deep links can point straight at it. */}
            <Route path="/my-day" element={<MyDay />} />

            <Route path="/leads" element={<LeadsPage />} />
            <Route path="/leads/:id" element={<LeadDetail />} />
            <Route path="/dead-leads" element={<DeadLeads />} />

            <Route path="/deals" element={<DealsPage />} />
            <Route path="/deals/:id" element={<DealDetail />} />

            <Route path="/quotes" element={<QuotesPage />} />
            <Route path="/quotes/new" element={<QuoteBuilder />} />
            <Route path="/quotes/:id" element={<QuoteBuilder />} />

            <Route path="/customers" element={<Customers />} />
            <Route path="/customers/:id" element={<CustomerDetail />} />
            {/* Back-compat with the old single customer route */}
            <Route path="/customer-360" element={<Navigate to="/customers" replace />} />
            <Route path="/customer-360/:id" element={<Navigate to="/customers" replace />} />

            <Route path="/inventory" element={<Inventory />} />
            <Route path="/vehicles"  element={<Navigate to="/inventory" replace />} />

            {/* Sales */}
            <Route path="/appointments" element={<Appointments />} />
            <Route path="/diary-settings" element={<DiarySettings />} />
            <Route path="/tasks" element={<Tasks />} />
            <Route path="/pipeline-settings" element={<PipelineSettings />} />

            {/* Showroom */}
            <Route path="/test-drives" element={<TestDrives />} />
            <Route path="/loan-cars" element={<LoanCars />} />
            <Route path="/appraisals" element={<Appraisals />} />

            {/* Marketing */}
            <Route path="/campaigns" element={<Campaigns />} />
            <Route path="/surveys" element={<Surveys />} />

            {/* Insights */}
            <Route path="/analytics" element={<Analytics />} />

            {/* Platform */}
            <Route path="/onboarding" element={<Onboarding />} />
            <Route path="/billing" element={<PlanBilling />} />
            <Route path="/health" element={<DealerHealth />} />

            <Route path="/service" element={<ServiceAdvisor />} />
            <Route path="/triage" element={<TriagePage />} />
            <Route path="/compliance" element={<CompliancePage />} />
            <Route path="/pilot-kpis" element={<PilotKpiScorecard />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/team" element={<Team />} />
            <Route path="/channel-monitor" element={<ChannelMonitor />} />
            <Route path="/help" element={<HelpPage />} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </RequireAccess>
        </main>
      </div>
      </UnreadLeadsProvider>
      </TourProvider>
      </CurrentUserProvider>
    </BrowserRouter>
  );
}
